const GETWebParams = (): any => {

  interface QueryParams {
    model?: string;
    version?: string;
    view?: string;
    color?: string;
    scenario?: string;
    lite?: string;

    utm_source?: string;
    utm_campaign?: string;
    utm_id?: string;
    utm_term?: string;
  }

  const getQueryParams = (): QueryParams => {
    const searchParams = new URLSearchParams(window.location.search);
    return {
        model: searchParams.get('model') || undefined,
        version: searchParams.get('version') || undefined,
        view: searchParams.get('view') || undefined,
        color: searchParams.get('color') || undefined,
        scenario: searchParams.get('scenario') || undefined,
        lite: searchParams.get('lite') || undefined,

        utm_source: searchParams.get('utm_source') || undefined,
        utm_campaign: searchParams.get('utm_campaign') || undefined,
        utm_id: searchParams.get('utm_id') || undefined,
        utm_term: searchParams.get('utm_term') || undefined,
    };
  };

  return getQueryParams();
};

export default GETWebParams;